// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__RGlpe","content":"styles_content__2-uZb","checkbox":"styles_checkbox__2xrQh","checkboxLabel":"styles_checkboxLabel__2R7lt"};